/**
 * @file Story
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Story component
 */
const vStory = () => {
	const stories = document.querySelectorAll('.v-story');

	if (!stories) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const hpStories = document.querySelector('.v-hp-stories');
	const isFeatured = hpStories && hpStories.classList.contains('v-hp-stories--featured');

	[...stories].forEach((story) => {
		const accordionBtn  = story.querySelector('.v-story__accordion-btn');
		const outerText     = story.querySelector('.v-story__text-outer');
		const storyText     = story.querySelector('.v-story__text-wrap');
		let isAnimating     = false;

		/**
		 * Toggle the accordion open or closed
		 */
		const toggleAccordion = () => {
			if (isAnimating) {
				return;
			}

			const isOpen = accordionBtn.getAttribute('aria-expanded') === 'true';

			const tl     = gsap.timeline({
				defaults: {
					ease: 'ease.out',
				},
				onStart: () => {
					isAnimating = true;
				},
				onComplete: () => {
					isAnimating = false;
				},
			});

			if (isOpen) {
				const fontSize   = parseFloat(window.getComputedStyle(storyText).fontSize);
				const lineHeight = parseFloat(window.getComputedStyle(storyText).lineHeight) / fontSize;
				const minHeight  = 5 * lineHeight * fontSize;

				tl
					.to(outerText, {
						maxHeight:  minHeight,
						onComplete: () => {
							accordionBtn.setAttribute('aria-expanded', 'false');
							outerText.removeAttribute('style');
						},
						onUpdate: () => {
							if (isFeatured) ScrollTrigger.refresh();
						},
					});
			} else {
				const openHeight = storyText.getBoundingClientRect().height;

				tl
					.to(outerText, {
						maxHeight: openHeight,
						onStart:   () => {
							accordionBtn.setAttribute('aria-expanded', 'true');
						},
						onUpdate: () => {
							if (isFeatured) ScrollTrigger.refresh();
						},
					});
			}
		};

		accordionBtn.addEventListener('click', toggleAccordion);
	});
};

export default vStory;
